module.exports = __webpack_public_path__ + "static/media/PE.174f2288.svg";